module.exports = __webpack_public_path__ + "img/ebook-zinio.af720376.png";